import { BooleanInput } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
  imports: [MatButtonModule, MatMenuModule, CommonModule, MatIconModule, MatDividerModule, RouterLink, TranslocoModule],
})
export class UserComponent implements OnInit, OnDestroy {
  // ...
  @Input() showAvatar: boolean = true;
  user: User | undefined;

  profileLink: any[] = ['/main']; // default fallback

  readonly _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    readonly _changeDetectorRef: ChangeDetectorRef,
    readonly _router: Router,
    readonly _userService: UserService,
  ) {}

  ngOnInit(): void {
    this._userService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user: User) => {
      this.user = user;

      const uname = (user as any)?.user_name ?? (user as any)?.username ?? user?.name ?? null;
      if (uname) {
        localStorage.setItem('user_name', uname);
      }

      this._changeDetectorRef.markForCheck();
    });

    this.updateProfileLink();

    this._router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll),
      )
      .subscribe(() => this.updateProfileLink());
  }
  private updateProfileLink(): void {
    const url = this._router.url;

    let baseSegment: 'aquaculture' | 'wild-harvest' | null = null;

    if (url.startsWith('/aquaculture')) {
      baseSegment = 'aquaculture';
    } else if (url.startsWith('/wild-harvest')) {
      baseSegment = 'wild-harvest';
    } else {
      const stored = localStorage.getItem('currentApp');

      if (stored === 'aquaculture' || stored === 'wild-harvest') {
        baseSegment = stored;
      }
    }

    this.profileLink = baseSegment ? [`/${baseSegment}/user-profile`] : ['/main'];

    this._changeDetectorRef.markForCheck();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  signOut(): void {
    this._router.navigate(['/sign-out']);
  }
}
